'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './messages.routes';

export class MessagesComponent {
  /*@ngInject*/
  constructor($state, $scope, $rootScope, fetch, lookup, userService, $stateParams) {
    this.$scope = $scope;
    this.$state = $state;
    this.fetch = fetch;
    this.lookup = lookup;
    this.$stateParams = $stateParams;
    this.userService = userService;
    this.currentPolicyType = null;
    this.messages = [];
    this.policyTypes = ["Density", "Housing Production Policy", "Housing Commercial Policy", "Parking", "Station Area Access", "Zoning" ]

    this.processNestedMessages = this.processNestedMessages.bind(this);

      // function to show messages by loading state.go(message-detail) with the submission_id as a parameter
      $scope.showMessages = function (row) {
        console.log(row);
        console.log(row);
        $state.go('message-detail', {
          submissionId: row.submission_id, // we're gonna group by submission now so pass it
          message_chain_id: row.message_chain_id,
          messageData: 'messages',
          data: row
        });
      };


  }

  $onInit(){

    this.userService.getCurrentUser()
    .then(response => {
      console.log(response)

      this.getJurisdictionList();
      this.$scope.currentUser = response.data;
      this.userService.setCurrentUser(response.data);
      this.fetchUserMessages();



    })
    .catch(err => {
      console.log(err);
      if(err.status === 403){
        this.$state.go('login');
      }
    })
  }




  fetchUserMessages() {
    if (!this.$scope.currentUser || !this.$scope.currentUser.id) {
      return Promise.reject(new Error('No user ID available'));
    }

    this.loading = true;

    return Promise.all([
      this.fetch.getAllItems(`api/messages/comments`),
    ])
      .then(messagesResponse => {
        console.log(messagesResponse[0].data);
        this.messages = this.processNestedMessages(messagesResponse[0].data, this.$scope.currentUser.organization);
        console.log('Messages received:', this.messages);

        // Calculate total counts across all nested messages
        this.messageCounts = this.messages.reduce((counts, thread) => {
            // unread counts should only include unread messages where to == user's org
          const threadUnread = thread.messages.filter(msg => msg.read_at === null && msg.to_jurisdiction === this.$scope.currentUser.organization).length;
          const threadRead = thread.messages.filter(msg => msg.read_at !== null).length;

          return {
            total: counts.total + thread.messages.length,
            unread: counts.unread + threadUnread,
            read: counts.read + threadRead
          };
        }, { total: 0, unread: 0, read: 0 });

        console.log('Message counts:', this.messageCounts);
        this.error = null;
      })
      .catch(err => {
        console.error('Error fetching messages:', err);
        this.error = 'Failed to load messages';
        this.messages = [];
        this.messageCounts = {
          total: 0,
          unread: 0,
          read: 0
        };
      })
      .finally(() => {
        this.loading = false;
        if (!this.$scope.$$phase) {
          this.$scope.$apply();
        }
      });
}

processNestedMessages(messages, organization) {
  console.log(messages);
  if (!messages || !messages.length) return [];

  // Group messages by message_chain_id
  const groupedThreads = messages.reduce(function(acc, message) {
      const chainId = message.message_chain_id;
      const submissionId = message.submission_id; // switching to grouping by submission_id
      // if (!acc[chainId]) {
      //     acc[chainId] = {
      //         message_chain_id: chainId,
      //         message_type: message.message_type,
      //         messages: [],
      //         unreadCount: 0,
      //         totalCount: 0,  // Initialize totalCount
      //         hasUnread: false,
      //         lastMessage: null
      //     };
      // }

      if (!acc[submissionId]) {
          acc[submissionId] = {
              submission_id: submissionId,
              message_chain_id: chainId,
              message_type: message.message_type,
              messages: [],
              unreadCount: 0,
              totalCount: 0,  // Initialize totalCount
              hasUnread: false,
              lastMessage: null,
              lastMessageDate: null,
              jurisdiction: message.jurisdiction,
              policy: message.submission_policy_name,
              policy_type: message.submission_policy_type,
              station_name: message.station_name
          };
      }

      // Add message to chain and check if unread

      console.log(message);
      console.log('update unread')
      console.log(organization)
      const isUnread = message.read_at === null && message.to_jurisdiction === organization;
      acc[submissionId].messages.push(Object.assign({}, message, {
          isUnread: isUnread,
          formattedDate: message.created_at ? new Date(message.created_at).toLocaleDateString() : ''
      }));

      // Update unread count
      if (isUnread) {
          acc[submissionId].unreadCount++;
          acc[submissionId].hasUnread = true;
      }

      // Update total count (number of messages in the thread)
      acc[submissionId].totalCount++;

      // Track most recent message
      if (!acc[submissionId].lastMessage ||
          new Date(message.created_at) > new Date(acc[submissionId].lastMessage.created_at)) {
          acc[submissionId].lastMessage = message;
          acc[submissionId].lastMessageDate= message.created_at
      }

      return acc;
  }, {});

  // Convert to array and sort by most recent message
  const threads = Object.keys(groupedThreads)
      .map(function(key) {
          var thread = groupedThreads[key];

          // Format lastMessage.updated_at similarly to formattedDate
          if (thread.lastMessage && thread.lastMessage.updated_at) {
              thread.lastMessage.formattedUpdatedAt = new Date(thread.lastMessage.updated_at).toLocaleDateString();
          }

          return Object.assign({}, thread, {
              messages: thread.messages.sort(function(a, b) {
                  return new Date(a.created_at) - new Date(b.created_at);
              })
          });
      })
      .sort(function(a, b) {
          return new Date(b.lastMessage.created_at) - new Date(a.lastMessage.created_at);
      });

  console.log('Processed threads:', threads);
  return threads;
}



  formatDate(date) {
    if (!date) {
      return '';
    }
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getMessageDate(messageGroup) {
    if (messageGroup && messageGroup.messages && messageGroup.messages.length > 0) {
      return messageGroup.messages[0].date;
    }
    return new Date(0);
  }


  getClosedCount() {
    return this.messages.filter(msg => msg.status === 'closed').length;
  }

  getInProgressCount() {
    return this.messages.filter(msg => msg.status === 'in_progress').length;
  }

  viewMessage(message) {
    // Implement view message logic
    console.log('Viewing message:', message);
  }

  replyToMessage(message) {
    // Implement reply logic
    console.log('Replying to message:', message);
  }

  markAsRead(message) {
    console.log(message)
    // Implement mark as read logic
    this.fetch.updateItem(`api/messages/${message.notify_id}/read`)
      .then(() => {
        message.status = 'read';
        // Refresh counts
        this.fetchUserMessages();
      })
      .catch(err => {
        console.error('Error marking message as read:', err);
      });
  }

  getUnreadCount(messages) {
    console.log('getting unread count');
    if (!messages || !messages.length) return 0;
    console.log(messages);
    console.log(this.$scope.currentUser);
    return messages.filter(msg => msg.read_at === null).length;
  }

  hasUnreadMessages(messages) {
    console.log("checking unread messages")
    console.log(messages);
    if (!messages || !messages.length) return false;
    return messages.some(msg => msg.read_at === null);
  }

  isRecentMessage(message) {
    const now = new Date();
    const messageDate = new Date(message.date);
    const hoursDiff = (now - messageDate) / (1000 * 60 * 60);
    return hoursDiff < 24; // Messages less than 24 hours old
  }

  hasRecentUnread(messages) {
    if (!messages || !messages.length) return false;
    return messages.some(msg =>
      msg.status !== 'read' && this.isRecentMessage(msg)
    );
  }

  /**
   * Get list of jurisdictions
   */
  getJurisdictionList = function() {
    this.fetch.getAllItems('api/data/jurisdictions/list')
      .then(response => {

        this.$scope.jurisdictions = response.data;
        this.$scope.jurisdiction = response.data[0].jurisdiction;
        // $scope.getStationAreaList($scope.jurisdiction);
      })
      .catch(err => {
        console.log(err);
      })
  }

  filterMessages = (jurisdiction, policyType) => {
    if (!this.allMessages) {
      this.allMessages = angular.copy(this.messages);
    }

    if (!jurisdiction && !policyType) {
      this.messages = this.allMessages;
      return;
    }

    if (jurisdiction && !policyType) {
      this.messages = this.allMessages.filter(msg =>
        msg.jurisdiction === jurisdiction
      );
    } else if (policyType && !jurisdiction) {
      this.messages = this.allMessages.filter(msg =>
        msg.policy_type === policyType
      );
    } else {
      this.messages = this.allMessages.filter(msg =>
        msg.jurisdiction === jurisdiction && msg.policy_type === policyType
      );
    }

  }

}


export default angular.module('appApp.messages', [uiRouter])
  .config(routes)
  .component('messages', {
    template: require('./messages.html'),
    controller: MessagesComponent,
    controllerAs: 'messagesCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/messages/messages.component.js